module.exports = __webpack_public_path__ + "static/img/27.b9b6061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/27.png
// module id = qXvm
// module chunks = 0